export const apartmentsGlobalSettings = {
  header: {
    title: "Ustawienia globalne",
    sub: "Dotyczy <strong>{count} apartamentu</strong> na koncie. | Dotyczy <strong>{count} apartamentów</strong> na koncie. | Dotyczy <strong>{count} apartamentów</strong> na koncie.",
    globalChip: "GLOBALNE",
  },
  sections: {
    activate: "Włącz silnik rezerwacji",
    payment: "Kiedy gość płaci?",
    hold: "Czas blokady",
    request: "Tryb zapytań",
    link: "Link do udostępnienia",
  },
  motor: {
    activeTitle: "Silnik aktywny",
    inactiveTitle: "Silnik nieaktywny",
    activeDesc: "Goście mogą rezerwować bezpośrednio przez link.",
    inactiveDesc: "Rezerwacje bezpośrednie są wyłączone we wszystkich apartamentach.",
    statusOn: "Aktywny",
    statusOff: "Nieaktywny",
  },
  payment: {
    onArrival: {
      name: "Płatność na miejscu",
      hint: "Rezerwacja bez opłaty, płatność przy przyjeździe.",
    },
    online: {
      name: "Płatność online",
      hint: "Płatność przy potwierdzeniu rezerwacji.",
    },
  },
  common: {
    saving: "Zapisywanie…",
    onlyOnlineBadge: "Tylko płatność online",
  },
  hold: {
    desc: "Kalendarz pozostaje zablokowany, dopóki gość nie dokończy płatności.<br>Jeśli nie zapłaci w ustawionym czasie, <strong>dostępność zostaje zwolniona automatycznie</strong>.",
  },
  units: {
    min: "min",
    hour: "godzina",
    hours: "godziny",
  },
  request: {
    enabledTitle: "Zapytania włączone",
    autoTitle: "Automatyczne potwierdzanie",
    enabledDesc: "Gość wysyła zapytanie. Zatwierdzenie lub odrzucenie odbywa się przez WhatsApp.",
    autoDesc: "Rezerwacja jest potwierdzana automatycznie po dokonaniu płatności.",
    tagControl: "Pełna kontrola nad tym, kto rezerwuje",
    tagWhatsapp: "WhatsApp przy każdym zapytaniu",
  },
  link: {
    desc: "Ten sam link do wszystkich apartamentów. Można go udostępnić w bio, kampaniach lub wiadomościach automatycznych.",
    copyTitle: "Kopiuj",
    viewVisitor: "Zobacz jako odwiedzający",
    shareWhatsapp: "Udostępnij przez WhatsApp",
  },
  callout: "Proszę wybrać apartament na pasku bocznym, aby ustawić <strong>Stawki</strong>, <strong>Promocje</strong> i <strong>Opłaty</strong> indywidualnie.",
  savebar: {
    unsaved: "Niezapisane zmiany czasu blokady i trybu zapytań",
    save: "Zapisz ustawienia",
  },
  toasts: {
    paymentUpdated: "Metoda płatności zaktualizowana.",
    paymentError: "Nie udało się zapisać metody płatności.",
    saved: "Ustawienia zapisane.",
    saveError: "Nie udało się zapisać.",
    linkCopied: "Link skopiowany.",
    copyError: "Nie udało się skopiować.",
  },
  share: {
    whatsappText: "Dzień dobry 👋 Oto link do rezerwacji: {link}",
  },
};
